import atob from 'atob';
import btoa from 'btoa';
import safeParse from './safeParse';
import sanitizeString from './Validation/sanitizeString';

export const stripEquals = (val: string): string => val.replace(/%3D|=/g, '');

function encodeString(val: any): string {
  try {
    return btoa(val);
  } catch (err) {
    // String is probably not in a format that btoa() can encode it
    return '';
  }
}

function decodeString(val: string): string {
  try {
    return atob(stripEquals(val));
  } catch (err) {
    // String is probably not in a format that atob() can decode it
    return '';
  }
}

export const stringifyAndEncode = (val: any): string =>
  val ? encodeString(JSON.stringify(val)) : '';

export type AnyObject = Record<string, any>;

export const decodeAndParse = <T extends AnyObject = AnyObject>(
  val: string
): Partial<T> =>
  val ? safeParse<T>(sanitizeString(decodeString(val))) ?? {} : {};
